import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { IncludedInModule } from '@portal-core/general/pipes/included-in/included-in.module';
import { SiteAvatarModule } from '@portal-core/sites/components/site-avatar/site-avatar.module';
import { ListModule } from '@portal-core/ui/list/list.module';
import { TeamSitesListComponent } from './team-sites-list.component';


@NgModule({
  declarations: [
    TeamSitesListComponent
  ],
  imports: [
    CommonModule,
    ListModule,
    MatIconModule,
    MatListModule,
    MatButtonModule,
    SiteAvatarModule,
    MatSnackBarModule,
    IncludedInModule
  ],
  exports: [
    TeamSitesListComponent
  ]
})
export class TeamSitesListModule { }
